import { useThemeContext } from "#contexts/ThemeContext";
import { Answer, EFieldType, EQuestionType, Field } from "#models/questionnaire";
import { hexToRgbA } from "#utils/color";
import { makeStyles } from '@material-ui/core';
import { colors } from '@swyft/ui';
import { FieldValidator, useField } from 'formik';
import * as React from 'react';
import { getDefaultValue, isEmail } from '../utils';

export const useLeadField = (field: Field) => {
  const { validateEmail, required, type } = field;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  let validateFunc: FieldValidator = () => {};
  if (required) {
    validateFunc = (value: any) => {
      const shouldRequired = type === EFieldType.Checkbox ? value !== 'true' : !value;
      if (shouldRequired) {
        return 'This is a required field';
      }
      return '';
    };
  }

  if (validateEmail) {
    validateFunc = (value: any) => {
      if (!value) {
        return 'This is a required field';
      }
      if (!isEmail(value)) return 'Invalid email format';
      return '';
    };
  }

  const [{ value: questionFieldSubmissions = [] }] = useField('questionFieldSubmissions');
  const fieldIndex = React.useMemo(
    () => questionFieldSubmissions.findIndex((f: any) => f.fieldId === field.id),
    [questionFieldSubmissions]
  );

  return useField({
    name: `questionFieldSubmissions.[${fieldIndex}].content`,
    validate: validateFunc,
    defaultValue: field.checked ? 1 : getDefaultValue(field.type)
  });
};

export const useFieldAnswer = ({
  answer,
  type,
  questionId
}: {
  answer: Answer;
  type: EQuestionType;
  questionId: string;
}) => {
  const { validate, required } = answer;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  let validateFunc: FieldValidator = () => {};

  validateFunc = (value: any) => {
    if (required && !value) {
      return 'This is a required field';
    }
    if (validate) {
      if (!value) {
        return 'This is a required field';
      } else if (!isEmail(value) && type === EQuestionType.Email) {
        return 'Invalid email format';
      }
    }
    return '';
  };

  return useField({
    name: `fieldAnswer.${answer.id}`,
    validate: validateFunc
  });
};

export const useFieldStyles = () => {
  const { primaryButtonBackground, contactFormHeadings, primaryButtonText } = useThemeContext();

  return makeStyles((theme?: any) => ({
    textField: {
      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: primaryButtonBackground
      },
      [theme.breakpoints.down('sm')]: {
        '& input, & select, & textarea': {
          fontSize: 16
        }
      },
      '&.placeHolder': {
        '& .MuiSelect-root': {
          color: colors.grey[300],
          opacity: 0.4
        }
      }
    },
    stylesLabel: {
      color: contactFormHeadings
    },
    menuItem: {
      '&:hover': {
        backgroundColor: hexToRgbA(primaryButtonBackground || '', 0.1),
        color: contactFormHeadings
      },
      '&.MuiListItem-root.Mui-selected, .MuiListItem-root.Mui-selected:hover': {
        backgroundColor: primaryButtonBackground,
        color: primaryButtonText
      },
      '&.placeHolder': {
        display: 'none'
      }
    },
    datePickerCustom: {
      '& .MuiPickersDay-daySelected': {
        border: `1px solid ${primaryButtonBackground} !important`
      },
      '& .MuiPickersDay-current': {
        backgroundColor: primaryButtonBackground + '!important'
      }
    }
  }))();
};
